export default __webpack_public_path__ + "static/media/white_time_icon.ac89050c.svg";